import {
  CALENDARNAV_CALENDAR_VIEW, CALENDARNAV_LIST_VIEW, CALENDARNAV_HYBRID_VIEW, CALENDARNAV_RESET
} from "../actions/actionCalendarNavBar";

const initialState = {
  viewType: ''
};

function reducerCalendarView(state = initialState, action) {
  switch (action.type) {
    case CALENDARNAV_CALENDAR_VIEW: {
      return { ...state, viewType: 'CalendarView' }
    }
    case CALENDARNAV_LIST_VIEW: {
      return { ...state, viewType: 'ListView' }
    }
    case CALENDARNAV_HYBRID_VIEW: {
      return { ...state, viewType: 'HybridView' }
    }
    case CALENDARNAV_RESET: {
      return { ...state, viewType: '' }
    }
    default: {
      return state;
    }
  }
}

export default reducerCalendarView;

